function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { RadioGroup, RadioButton } from '@homeaway/react-form-components';
import "./MultiExampleHarness.css";

var MultiExampleHarness = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MultiExampleHarness, _Component);

  function MultiExampleHarness(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.toggleExample = function (event) {
      _this.setState({
        index: parseInt(event.target.value, 10)
      });
    };

    _this.state = {
      index: 0
    };
    return _this;
  }

  var _proto = MultiExampleHarness.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var examples = this.props.examples;
    var index = this.state.index;
    var radioButtonRow = [];
    var contentPieces = '';

    if (examples.length > 1) {
      radioButtonRow = examples.map(function (example, i) {
        return /*#__PURE__*/React.createElement(RadioButton, {
          label: example.label,
          value: i,
          key: i,
          size: "sm",
          checked: index === i,
          onChange: _this2.toggleExample,
          inline: true
        });
      });
      contentPieces = typeof examples[index].content === 'undefined' ? /*#__PURE__*/React.createElement("p", {
        className: "text-danger",
        dangerouslySetInnerHTML: {
          __html: 'Error: Example content not found.'
        }
      }) : examples[index].content.map(function (content) {
        return /*#__PURE__*/React.createElement(Fragment, null, content);
      });
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "MultiExampleHarness"
    }, /*#__PURE__*/React.createElement("article", {
      className: "MultiExampleHarness__article"
    }, /*#__PURE__*/React.createElement("header", {
      className: "MultiExampleHarness__header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "MultiExampleHarness__header-container"
    }, examples.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: "MultiExampleHarness__header-labels"
    }, /*#__PURE__*/React.createElement("form", {
      className: "MultiExampleHarness__header-labels-form"
    }, /*#__PURE__*/React.createElement(RadioGroup, {
      name: "MultiExampleHarnessChoice",
      ariaLabel: "Different example views"
    }, radioButtonRow))))), /*#__PURE__*/React.createElement("div", {
      className: "MultiExampleHarness__body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "MultiExampleHarness__content"
    }, contentPieces), /*#__PURE__*/React.createElement("div", {
      className: "MultiExampleHarness__image"
    }, typeof examples[index] !== 'undefined' && typeof examples[index].image !== 'undefined' && /*#__PURE__*/React.createElement("img", {
      src: examples[index].image.src,
      alt: examples[index].image.alt,
      width: "100%"
    })))));
  };

  return MultiExampleHarness;
}(Component);

MultiExampleHarness.propTypes = {
  /** An array used to populate the Multi Example. */
  examples: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.shape({
      // Supporting image for the example
      src: PropTypes.string,
      alt: PropTypes.string
    }),
    content: PropTypes.array,
    // An array used to hold HTML children to provide content for the example
    label: PropTypes.string // Used for the radio button group labels.

  }))
};
export default MultiExampleHarness;
//# sourceMappingURL=MultiExampleHarness.js.map